import React, { useState, useEffect } from 'react';
import {
  ProspectingClientContainer,
  ProspectingClientWrapper,
  ProspectingClientSubtitle,
  ProspectingClientInfo,
  ProspectingClientIcon,
  ProspectingClientInfoParagraph
} from './styles';
import { BsInfo, BsXCircle, BsExclamation } from 'react-icons/bs';
import parse from 'html-react-parser';
import colors from '../../../assets/styles/colors';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import { FormFooter, FormFooterRigth } from '../../../components/FormTemplate/styles';
import { setNewEstado } from '../../../services/habeasData';
import { useLocation ,useHistory} from 'react-router-dom';
import Loader from '../../../components/Loader';
import { getSolicitationById } from '../../../services/solicitations';
import { getPilotoValidacionIdentidad } from '../../../services/desk';
import AlertaValidacionIdentidad from '../../../components/AlertaValidacionIdentidad';


const ProspectingClientPage = ({ setLastStep, setTitle, setSubTitle, setShowSteps, open }) => {
  const [ sent, setSent ] = useState(false);
  const [ expired, setExpired ] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [nuevoFlujoIdentidad, setNuevoFlujoIdentidad] = useState(false);


  async function nextStep() {
   try {
    setIsLoading(true);
    const response = await setNewEstado(location.idCredit,'EN_REGISTRO_CLIENTE');
    setIsLoading(false);
    history.push({
      pathname: '/admin/client-registration/',
      idCredit: location.idCredit,
      idSimulation: location.idSimulacion
    });
   } catch (error) {
    
   }
  }

  async function initializeStateComponent() {
    try {
      setIsLoading(true);
      const requestData = await getSolicitationById(location.idCredit);
      const oficinaAutovalidation = await getPilotoValidacionIdentidad(requestData.data.credito.idOficina);
      if(!oficinaAutovalidation.data.unificado){
        setNuevoFlujoIdentidad(true);
      }else{
        setNuevoFlujoIdentidad(false);
        history.push({
          pathname: '/admin/client-registration/',
          step: 6,
          idCredit: location.idCredit,
          idSimulation: location.idSimulacion
        });
      }
      setIsLoading(false);
    } catch (error) {
      
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, []);

  return (
    <ProspectingClientContainer id="prospectin-step-page">
      <ProspectingClientWrapper>
        <ProspectingClientSubtitle>Solicitud en prospección exitosa</ProspectingClientSubtitle>
        <ProspectingClientInfo>
          <ProspectingClientIcon>
            {
              expired 
                ? <BsXCircle size={20} color={colors.bgDanger} id="habeas-data-status-icon" />
                : <BsInfo size={20} color={colors.bgPrimary} id="habeas-data-status-icon" />
            }
          </ProspectingClientIcon>
          {
            expired ?
            // Expiró el OTP del cliente
            <ProspectingClientInfoParagraph>
              El OTP del cliente ha expirado, se deberá contactar con el cliente para poder retomar la operación.
            </ProspectingClientInfoParagraph>
            // No expiró el OTP del cliente
            :
            <ProspectingClientInfoParagraph>
              Consulta a tu cliente en pendientes por radicar.
            </ProspectingClientInfoParagraph>
          }
        </ProspectingClientInfo>
        {nuevoFlujoIdentidad && 
         <FormFooterRigth>
         <SecondaryLargeButton type='button' onClick={() => nextStep()}>Siguiente</SecondaryLargeButton>
       </FormFooterRigth>
       }

      </ProspectingClientWrapper>
      {isLoading && <Loader />}
    </ProspectingClientContainer>
  )
}

export default ProspectingClientPage
